'use client';

import Link from 'next/link';
import { analytics } from '@/lib/analytics';

const TonesLink = ({ href }: { href: string }) => {
  const onLinkClick = (href: string) => {
    const isDarkglassLink = href.includes('darkglass.com');
    analytics.capture('tone.link.clicked', { href, isDarkglassLink });
  };
  return (
    <Link
      className="text-nowrap overflow-hidden text-ellipsis"
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={() => onLinkClick(href)}
    >
      {href}
    </Link>
  );
};

export default TonesLink;
